import { useEffect, useState } from "react";
import { Avatar, Button, Header } from "react-dsgov";
import { useNavigate } from "react-router";
import useBusca from "../../hooks/useBusca";
import useSubtituloState from "../../state/hooks/useSubtituloState";
import useCatalogoService from "../../hooks/useCatalogoService";
import usePortalAuth from "../../hooks/usePortalAuth";
import { getPortalTitle, isPortalInteroperabilidade } from "../../config/portalMode";

export interface ISiteHeaderProps {
    showSearchBar?: boolean
    showDocumentacoes?: boolean
}

const SiteHeader : React.FC<ISiteHeaderProps> = ({showSearchBar = true, showDocumentacoes = false}) => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [urlAvatar, setUrlAvatar] = useState("")
    const catalogoService = useCatalogoService();
    const [subtitulo, ] = useSubtituloState();
    const busca = useBusca();
    const navigate = useNavigate();
    const hideLogin = isPortalInteroperabilidade();

    const auth = usePortalAuth();
    
    useEffect(() => {
        if (hideLogin || !auth.isAuthenticated) {
            setUrlAvatar("");
            return;
        }

        catalogoService.getAvatar().then((url) => setUrlAvatar(url));
    }, [auth.isAuthenticated, catalogoService, hideLogin]);

    return (
        <Header 
            urlLogo="/logo-govbr.svg" 
            systemName="Tesouro Nacional" 
            title={getPortalTitle()} 
            subTitle={subtitulo}
            showMenuButton={false}

            quickAccessLinks={[
                {label: 'Sobre o Portal', href: () => {navigate("/sobre")}},
                ...(showDocumentacoes ? [{label: hideLogin ? 'Manuais' : 'Documentações', href: () => {navigate("/docs")}}] : []),
                ...(!hideLogin ? [{label: 'Catálogo de Componentes', href: () => {navigate("/catalogo-componentes")}}] : []),
                {label: 'Catálogo de APIs', href: () => {navigate("/catalogo-apis")}},
                ...(!hideLogin ? [{label: 'Assistente', href: () => {navigate("/assistente")}}] : []),
                //{label: 'Comunidade', href: () => {navigate("/comunidade")}},
            ]}

            /*
            features={[
                {label: 'Funcionalidade 1', icon: 'fas fa-chart-bar', href: 'https://google.com/'},
                {label: 'Funcionalidade 2', icon: 'fas fa-headset', onClick: () => {alert('Clicou!');} },
                {label: 'Funcionalidade 3', icon: 'fas fa-comment'},
                {label: 'Funcionalidade 4', icon: 'fas fa-adjust'},
            ]}
            */

            loggedIn={!hideLogin && auth.isAuthenticated}
            showLoginButton={!hideLogin}
            onClickLogin={hideLogin ? undefined : (() => {
                auth.signinRedirect({redirect_uri: window.location.href});
            })}

            onSearch={(searchTerm) => {
                busca(searchTerm);
            }}

            showSearchBar={showSearchBar}

            avatar={!hideLogin && auth.isAuthenticated ? (
                <>
                    <Avatar imageSrc={urlAvatar} />
                    <Button 
                        mx={2} 
                        primary
                        onClick={() => {auth.signoutRedirect({post_logout_redirect_uri: window.location.href.replace(window.location.search, '')})}}
                    >
                        <i className="fas fa-sign-out-alt"></i> Sair
                    </Button>
                </>
            ) : undefined}
        />
    );
}

export default SiteHeader;